module.exports = __webpack_public_path__ + "img/P150T_weapon_131.f242e6d3.png";